import { Box, Typography, Link } from "@mui/material";

export const TestimonialCard = (props) => {
  const styles = {
    body1: {
      fontSize: { xs: 10, sm: 13, md: 16, lg: 16, xl: 17 },
    },
    h4: {
      fontSize: { xs: 18, sm: 22, md: 24, lg: 28, xl: 32 },
      // mt: { xs: 5, sm: 6, md: 7, lg: 8, xl: 9 },
    },
    h5: {
      fontSize: { xs: 13, sm: 16, md: 18, lg: 22, xl: 24 },
    },
    linkedInLink: {
      textDecoration: "none",
      "&:hover": {
        textDecoration: "none",
      },
    },
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        backgroundColor: "#000000",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      <Box
        sx={{
          mx: { xs: 2, sm: 8, md: 10 },
        }}
      >
        <Typography align="center" variant="body1" sx={styles.body1}>
          {props.text.paragraph1}
          <br /> <br />
          {props.text.paragraph2}
        </Typography>
      </Box>
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          pb: { xs: 5, sm: 5, md: 7 },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {props.linkedIn ? (
          <Link
            href={props.linkedIn}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              ...styles.linkedInLink,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              align="center"
              variant="h5"
              sx={{ ...styles.h5, color: "primary.main" }}
            >
              {props.name}
            </Typography>
            <Typography align="center" variant="body1" sx={styles.body1}>
              {props.position}
            </Typography>
          </Link>
        ) : (
          <>
            <Typography
              align="center"
              variant="h5"
              sx={{ ...styles.h5, color: "primary.main" }}
            >
              {props.name}
            </Typography>
            <Typography align="center" variant="body1" sx={styles.body1}>
              {props.position}
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );
};
